import { useContext } from "react";

import { AxiosContext } from "@src/config/axios/AxiosContext";

const useAxios = () => useContext(AxiosContext);

export default useAxios;
